var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-btn",
    {
      class: _vm.isOuter ? "speed-Dial-internal" : "main-fab-btn",
      attrs: { fab: "" },
      model: {
        value: _vm.fabModel,
        callback: function($$v) {
          _vm.fabModel = $$v
        },
        expression: "fabModel"
      }
    },
    [
      _vm.fab
        ? _c("v-icon", { attrs: { color: "#1A73E8" } }, [_vm._v(" mdi-close ")])
        : _c("v-icon", { attrs: { color: "#1A73E8" } }, [_vm._v(" mdi-plus ")])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }